import EstimateForm from "@/components/forms/EstimateForm";
import { BUSINESS } from "@/lib/site";
import { Phone } from "lucide-react";

export default function ContactBlock({ source = "homepage_contact_block" }) {
  return (
    <section id="estimate" data-testid="contact-block" className="section-pad bg-brand-obsidian text-brand-bone">
      <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="overline mb-3 text-brand-olive">Free estimates</p>
          <h2 className="font-heading text-4xl md:text-5xl font-extrabold tracking-tighter leading-tight">
            Tell us about your project.
          </h2>
          <p className="text-brand-bone/80 mt-5 max-w-md leading-relaxed">
            Share a few details and we'll get back within one business day. Need it sooner? Call us directly.
          </p>
          <a href={BUSINESS.phoneHref} className="inline-flex items-center gap-2 mt-8 text-brand-bone font-heading text-2xl font-bold hover:text-white" data-testid="contact-block-phone">
            <Phone className="w-5 h-5 text-brand-olive" /> {BUSINESS.phone}
          </a>
          <p className="text-xs text-brand-bone/60 mt-2">{BUSINESS.hours}</p>
        </div>
        <div className="lg:col-span-7">
          <div className="rounded-md bg-brand-obsidian-hover/40 border border-white/10 p-6 md:p-8">
            <EstimateForm source={source} variant="dark" />
          </div>
        </div>
      </div>
    </section>
  );
}
